import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { ILinkCardProps } from './LinkCard.interface';

import './style.scss';

const LinkCard: FC<ILinkCardProps> = ({ className, description, title, url }) => (
  <NavLink className={cn('link-card', className)} to={url}>
    <div className="link-card__description">{description}</div>

    <div className="link-card__title">{title}</div>
  </NavLink>
);

export default LinkCard;
